import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M8 12h8M2.5 12h2m15 0h2m-17-4.25a1.75 1.75 0 1 1 3.5 0v8.5a1.75 1.75 0 1 1-3.5 0zm11.5 0a1.75 1.75 0 1 1 3.5 0v8.5a1.75 1.75 0 1 1-3.5 0z"
    }, null, -1)
  ])))
}
export default { render: render }